<span class="status-badge" [class]="modifier()">{{ label() }}</span>
